import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { Trans } from 'react-i18next';
import { Button, Col, Modal, Row, Text } from '@ui';

const AmendAndWithdrawSection = () => {
  const { t } = useTranslation(['onboarding', 'common']);
  const { amendApplication, withdrawApplication } =
    useEntityIntakeFormContext();

  const handleWithdrawClick = () => {
    Modal.confirm({
      title: t('intake_form.withdraw_section.confirmation_modal.title'),
      width: 600,
      icon: null,
      closable: true,
      maskClosable: true,
      content: (
        <>
          <Text gutterBottom>
            {t(
              'intake_form.withdraw_section.confirmation_modal.description_line_1',
            )}
          </Text>
          <Text>
            <Trans
              t={t}
              i18nKey="intake_form.withdraw_section.confirmation_modal.description_line_2"
              components={[
                <Text
                  weight="semi-bold"
                  variant="span"
                  color={colorsTheme.colorWhite}
                />,
              ]}
            />
          </Text>
        </>
      ),
      okText: t('confirm', { ns: 'common' }),
      async onOk() {
        await withdrawApplication();
      },
    });
  };

  return (
    <Row gutter={[24, 24]}>
      <Col span={12}>
        <MinHeightWrapper>
          <StyledText variant="h4" gutterBottom>
            {t('intake_form.amend_section.title')}
          </StyledText>
          <StyledText>{t('intake_form.amend_section.description')}</StyledText>
        </MinHeightWrapper>
        <Button size="large" onClick={amendApplication}>
          {t('intake_form.amend_section.button')}
        </Button>
      </Col>
      <Col span={12}>
        <MinHeightWrapper>
          <StyledText variant="h4" gutterBottom color={colorsTheme.colorWhite}>
            {t('intake_form.withdraw_section.title')}
          </StyledText>
          <StyledText>
            {t('intake_form.withdraw_section.description')}
          </StyledText>
        </MinHeightWrapper>
        <Button size="large" danger onClick={handleWithdrawClick}>
          {t('intake_form.withdraw_section.button')}
        </Button>
      </Col>
    </Row>
  );
};

const StyledText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.marginSm};
`;

const MinHeightWrapper = styled.div`
  min-height: 100px;
`;

export default AmendAndWithdrawSection;
